/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { Box, Flex, FormattedCurrency, Heading, Txt, Row, Col } from '../../components'
import { FormattedUserName } from '../../components/FormattedUserName'
import { IModalProps, Modal } from '../../components/Modal'
import { PlayingCard } from '../../components/PlayingCard'
import { ID, Model } from '../../sharedBetweenServerAndClient__DO_NOT_EDIT/types'
import { Ellipsis } from '../../components/Ellipsis'
import { getUserHandSolution } from '../../utils/getUserHandSolution'
import { getCanManuallyShowHand } from '../../utils/gameHandUtils'
import { AsyncActionButton } from '../../components/AsyncActionButton'
import { getFunction } from '../../utils/api'
import _ from 'lodash'

export const GameHandDetailsModalHeader: React.SFC<{}> = () => (
  <Heading as="h3">Community Cards</Heading>
)

export const GameHandDetailsModal: React.SFC<{
  currentUserId: string
  gameHand: Model.GameHand
  usersMap: Record<ID, Model.User>
}> = ({ gameHand, usersMap, currentUserId }) => {
  const finalResult = gameHand.finalResult!
  return (
    <React.Fragment>
      <Box>
        {gameHand.visibleCards.map((card, index) => (
          <PlayingCard key={index} width={50} sx={{ mr: 3 }} card={card} />
        ))}
      </Box>
      <Heading as="h3" mt={5}>
        Visible Cards
      </Heading>
      <Row sx={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: 3 }}>
        <Col xs={4}>User</Col>
        <Col xs={5}>Cards</Col>
        <Col xs={3}>Winnings</Col>
      </Row>
      {_.compact([
        finalResult.handEndedPrematurelyInfo,
        ...finalResult.automaticallyVisibleUserHands,
        ...(finalResult.manuallyVisibleUserHands || []),
      ]).map((solvedHand, index) => {
        const solution =
          'cards' in solvedHand ? getUserHandSolution({ cards: solvedHand.cards, gameHand }) : null
        const amountWon = (solvedHand as Model.SolvedUserHand).amountWon
        return (
          <Row sx={{ alignItems: 'center', mt: 4 }} key={index}>
            <Col xs={4}>
              <Ellipsis>
                <FormattedUserName user={usersMap[solvedHand.userId]} />
              </Ellipsis>
            </Col>
            <Col xs={5}>
              <Txt>
                {'cards' in solvedHand
                  ? solvedHand.cards.map((card, index) => (
                      <PlayingCard width={50} key={index} sx={{ mr: 3 }} card={card} />
                    ))
                  : '--'}
              </Txt>
              <Txt>{solution && solution.descr}</Txt>
            </Col>
            <Col xs={3} sx={{ color: 'lightGreen', fontSize: 4, fontWeight: 'bold' }}>
              {amountWon && amountWon > 0 ? <FormattedCurrency amount={amountWon} /> : '--'}
            </Col>
          </Row>
        )
      })}

      {getCanManuallyShowHand(gameHand, currentUserId) && (
        <Box sx={{ mt: 4 }}>
          <AsyncActionButton
            size="lg"
            loadingVariant="light"
            action={() =>
              getFunction('showCurrentUsersCards')({
                gameHandId: gameHand.id,
                gameId: gameHand.gameId,
              })
            }
            errorLabel="showCurrentUsersCards"
            variant="lightGreen"
          >
            Show Your Hand
          </AsyncActionButton>
        </Box>
      )}
    </React.Fragment>
  )
}
